export class StatusPessoa  {
    id: number;    
	descricao: string;    
}